import { useState } from "react";
import styled from "styled-components";

import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";

const ModalTitle = styled.h3`
    margin: 0 0 18px 0;
    padding: 0 0 12px 2px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 15px;
    font-weight: 700;
    color: #263b4b;
    text-align: left;
    width: 100%;
`;

const ModalNovoItem = ({ tipoId, item, onSaved }) => {
    const { closeModal } = useModal();
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();

    const isEdicao = Boolean(item?.id);

    const [descricao, setDescricao] = useState((item?.descricao ?? "").toUpperCase());
    const [pontos, setPontos] = useState(
        item?.pontos != null ? String(item.pontos) : ""
    );
    const [ordem, setOrdem] = useState(
        item?.ordem != null ? String(item.ordem) : ""
    );
    const [salvando, setSalvando] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const descricaoTrim = descricao.trim();
        if (!descricaoTrim) {
            notifyError("Informe a descrição do item.");
            return;
        }

        if (pontos === "") {
            notifyError("Informe a pontuação do item.");
            return;
        }

        try {
            setSalvando(true);

            const { data } = await api.post("/Painel/API/Prossmap/Itens/Save/index.php", {
                id: item?.id ?? null,
                tipo_id: tipoId,
                descricao: descricaoTrim,
                pontos: Number(pontos),
                ordem: ordem === "" ? 0 : Number(ordem),
            });

            if (data?.success) {
                notifySuccess(
                    data?.message ||
                        (isEdicao ? "Item atualizado com sucesso." : "Item cadastrado com sucesso.")
                );
                if (onSaved) await onSaved();
                closeModal();
                return;
            }

            notifyError(data?.message || "Não foi possível salvar o item.");
        } catch (err) {
            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao salvar item.";
            notifyError(msg);
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Overlay state>
            <Modal header close={closeModal} size="md">
                <ModalTitle>{isEdicao ? "EDITAR ITEM" : "NOVO ITEM"}</ModalTitle>
                <Formulario onSubmit={handleSubmit}>
                    <FormComp
                        title="DESCRIÇÃO"
                        type="textarea"
                        valor={descricao}
                        changeFunc={(e) => setDescricao(e.target.value.toUpperCase())}
                        required
                    />
                    <FormComp
                        title="PONTOS"
                        type="numberOnly"
                        valor={pontos}
                        changeFunc={(e) => setPontos(e.target.value)}
                        placeholder="Ex.: 1"
                        required
                    />
                    <FormComp
                        title="ORDEM"
                        type="numberOnly"
                        valor={ordem}
                        changeFunc={(e) => setOrdem(e.target.value)}
                        placeholder="Ex.: 1"
                    />
                    <FormComp
                        type="submit"
                        valor={salvando ? "SALVANDO…" : "SALVAR"}
                        disabled={salvando}
                    />
                </Formulario>
            </Modal>
        </Overlay>
    );
};

export default ModalNovoItem;
